import { AmplitudeEvent } from "@/telemetry/AmplitudeEvent";

export class HealthAssessmentShowMyScoresEvent extends AmplitudeEvent {
	constructor( surveyId, surveyDate, teamName, isShowing ) {
		super();
		this.name = "Health Assessment - Show My Scores";
		this.eventProperties.instance_id = surveyId;
		this.eventProperties.instance_name = surveyDate;
		this.eventProperties.team_name = teamName;
		this.eventProperties.state = isShowing ? "show" : "hide";
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/HealthAssessmentShowMyScoresEvent.js